import { useTranslation } from 'react-i18next'
import React, { useEffect, useState } from 'react'
import styles from './Europass.module.scss'
import { Layout } from 'components'
import ProfilePage from 'pages/ProfilePage/ProfilePage'
import userInfo from 'utils/userInfo'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import {
  setEuropass,
  setPersonalInfo,
  setUser_change,
} from 'store/slices/PersonalCard'
import { getPersonalEmployee } from 'service/PersonalCardService'

const Europass = () => {
  const { t } = useTranslation('common')

  const user = userInfo()
  const [render, setRender] = useState(false)

  const info = useSelector((state) => state.personalcard.personal_info)
  const navigate = useNavigate()
  let data
  const dispatch = useDispatch()
  const [email, setEmail] = useState(false)
  const [phone, setPhone] = useState(false)
  const [citizen, setCitizen] = useState(false)
  const [address, setAddress] = useState(false)
  const [birth_date, setBirth_date] = useState(false)
  const [education, setEducation] = useState(false)
  const [diplomatic, setDiplomatic] = useState(false)
  const [military, setMilitary] = useState(false)
  const [activity, setActivity] = useState(false)
  const [trainQualif, setTrainQualif] = useState(false)
  const [profession, setProfession] = useState(false)

  const getDataStart = async () => {
    try {
      let response = await getPersonalEmployee(data, 'ru')

      dispatch(
        setPersonalInfo({
          personal_info: response.data,
        }),
      )
    } catch (error) {}
  }

  useEffect(() => {
    getDataStart()

    setRender(false)
  }, [render])

  const getData = async () => {
    try {
      const check = { ...info }
      const change_user = { ...user }
      if (phone) {
        change_user.numberPhone = null
      }
      if (email) {
        change_user.email = null
      }

      if (citizen) {
        change_user.education = null
      }
      if (address) {
        info.birth_place.street = null
      }
      if (birth_date) {
        change_user.dataOfBirth = null
      }
      if (education) {
        check.education = null
      }
      if (diplomatic) {
        check.ranks = null
      }
      if (military) {
        check.military_registration = null
      }
      if (activity) {
        check.awards = null
      }
      if (trainQualif) {
        check.trainings = null
      }
      if (profession) {
        check.surname = null
      }
      dispatch(
        setEuropass({
          Europass: check,
        }),
      )
      dispatch(
        setUser_change({
          user_change: change_user,
        }),
      )
    } catch (error) {}
  }

  useEffect(() => {
    getData()
  }, [
    email,
    phone,
    citizen,
    address,
    birth_date,
    education,
    diplomatic,
    military,
    activity,
    trainQualif,
    profession,
  ])

  return (
    <Layout>
      <div className={styles.personal_wrapper}>
        <div className={styles.header}>
          <h3 className={styles.Personal_Card}>{t('europass.personal_card')}</h3>
          <div className={styles.header_body}>
            
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
              <button className={styles.btn1} style={{}}>
                Русский{' '}
              </button>
              <button
                className={styles.btn1}
                onClick={() => navigate('/europassen')}
              >
                English
              </button>
              <button
                className={styles.btn1}
                onClick={() => navigate('/europassky')}
              >
                Кыргызча
              </button>
            </div>
          </div>
        </div>
        <button
          style={{ width: '150px', marginLeft: '30px' }}
          onClick={() => navigate('/personalcard')}
          className={styles.btn1}
        >
          Назад
        </button>

        <div className={styles.body}>
          <h3>{t('auto.europass_europass.k1')} </h3>

          <div className={styles.list}>
            <h3>{t('employees.step_personal')}</h3>
            <div className={styles.item}>
              <input
                onChange={(e) => setEmail(e.target.checked)}
                checked={email}
                type="checkbox"
                className={styles.radio}
              />
              <div>
                <h4>{t('europass.email')}</h4>
                <p>{user?.email}</p>
              </div>
              <div className={styles.item}>
                <input
                  onChange={(e) => setPhone(e.target.checked)}
                  checked={phone}
                  type="checkbox"
                  className={styles.radio}
                />
                <div>
                  <h4>{t('user.phone')}</h4>
                  <p>{user?.numberPhone}</p>
                </div>
              </div>
              <div className={styles.item}>
                <input type="checkbox" className={styles.radio} />
                <div>
                  <h4>{t('foreign.col_citizenship')}</h4>
                  <p>{info?.citizenship}</p>
                </div>
              </div>
              
              <div className={styles.item}>
                <input
                  onChange={(e) => setBirth_date(e.target.checked)}
                  checked={birth_date}
                  type="checkbox"
                  className={styles.radio}
                />
                <div>
                  <h4>{t('user.birth_date')}</h4>
                  <p>{user?.dataOfBirth}</p>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.list}>
            <h3>{t('students.step_education')}</h3>
            <div className={styles.item}>
              <input
                onChange={(e) => setEducation(e.target.checked)}
                checked={education}
                type="checkbox"
                className={styles.radio}
              />
              <div>
                <h4>{t('europass.university')}</h4>
                <p>{info.education?.institution}</p>
              </div>
              <div className={styles.item}>
                <div>
                  <h4>{t('archive.col_faculty')}</h4>
                  <p>{info?.education?.department}</p>
                </div>
              </div>
              <div className={styles?.item}>
                <div>
                  <h4>{t('archive.col_specialty')}</h4>
                  <p>{info?.education?.qualification}</p>
                </div>
              </div>
              <div className={styles?.item}>
                <div>
                  <h4>{t('europass.study_start')}</h4>
                  <p>{info?.education?.entered}</p>
                </div>
              </div>
              <div className={styles.item}>
                <div>
                  <h4>{t('europass.study_end')}</h4>
                  <p>{info?.education?.graduated}</p>
                </div>
              </div>
            </div>
          </div>
          {info?.ranks?.length === 0 ? null : (
            <div className={styles.list}>
              <h3>{t('auto.europass_europass.k2')} </h3>
              <div className={styles.item}>
                <input
                  onChange={(e) => setDiplomatic(e.target.checked)}
                  checked={diplomatic}
                  type="checkbox"
                  className={styles.radio}
                />
                <div></div>
                <div className={styles.item}>
                  <div>
                    <h4>{t('common.name')}</h4>
                    <p>{info?.ranks?.slice(-1)[0]?.title}</p>
                  </div>
                </div>
                <div className={styles.item}>
                  <div>
                    <h4>{t('europass.rank')}</h4>
                    <p>{info?.ranks?.slice(-1)[0]?.rank}</p>
                  </div>
                </div>
                <div className={styles.item}>
                  <div>
                    <h4>{t('pages.ordersPage.date_field')}</h4>
                    <p>{info?.ranks?.slice(-1)[0]?.assigned}.</p>
                  </div>
                </div>
                <div className={styles.item}></div>
              </div>
            </div>
          )}

          <div className={styles.list}>
            <h3>{t('auto.europassmilitary_europassmilitary.k1')} </h3>
            <div className={styles.item}>
              <input
                onChange={(e) => setMilitary(e.target.checked)}
                checked={military}
                type="checkbox"
                className={styles.radio}
              />
              <div>
                <h4>{t('europass.fitness')}</h4>
                {info?.military_registration?.is_fit ? (
                  <p>{t('europass.fit')}</p>
                ) : (
                  <p>{t('europass.not_fit')}</p>
                )}
              </div>
              <div className={styles.item}>
                <div>
                  <h4>{t('europass.draft_board')}</h4>
                  <p>{info?.military_registration?.draft_board}</p>
                </div>
              </div>
              <div className={styles.item}>
                <div>
                  <h4>{t('europass.composition')}</h4>
                  <p>{info?.military_registration?.composition}</p>
                </div>
              </div>
              <div className={styles.item}>
                <div>
                  <h4>{t('europass.vus')}</h4>
                  <p>{info?.military_registration?.rank}</p>
                </div>
              </div>
              <div className={styles.item}>
                <div>
                  <h4>{t('europass.military_rank')}</h4>
                  <p>{info?.military_registration?.specialty}</p>
                </div>
              </div>
              <div className={styles.item}>
                <div>
                  <h4>{t('europass.troop_kind')}</h4>
                  <p>{info?.military_registration?.troop_kind}</p>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.list}>
            <h3>{t('auto.europass_europass.k3')} </h3>
            <div className={styles.item}>
              <input
                onChange={(e) => setActivity(e.target.checked)}
                checked={activity}
                type="checkbox"
                className={styles.radio}
              />
              <div>
                <h4>{t('archive.col_specialty')}</h4>
                <p>{info?.employment?.professional_experience}</p>
              </div>
              <div className={styles.item}>
                <div>
                  <h4>{t('europass.total')}</h4>
                  <p>{info?.employment?.total_experience}</p>
                </div>
              </div>
              <div className={styles.item}>
                <div>
                  <h4>{t('europass.public_service')}</h4>
                  <p>{info?.employment?.public_service_experience}</p>
                </div>
              </div>
              <div className={styles.item}>
                <div>
                  <h4>{t('europass.private_service')}</h4>
                  <p>{info?.employment?.private_service_experience}</p>
                </div>
              </div>
            </div>
          </div>

          {info?.trainings?.length === 0 ? null : (
            <div className={styles.list}>
              <h3>{t('europass.training')}</h3>
              <div className={styles.item}>
                <input
                  onChange={(e) => setTrainQualif(e.target.checked)}
                  checked={trainQualif}
                  type="checkbox"
                  className={styles.radio}
                />

                <div>
                  <h4>{t('diploma.topic')}</h4>
                  <p>{info?.trainings?.slice(-1)[0]?.title}</p>
                </div>
                <div className={styles.item}>
                  <div>
                    <h4>{t('archive.info_period_start')}</h4>
                    <p>{info?.trainings?.slice(-1)[0]?.started}</p>
                  </div>
                </div>
                <div className={styles.item}>
                  <div>
                    <h4>{t('calendar.end')}</h4>
                    <p>{info?.trainings?.slice(-1)[0]?.ended}</p>
                  </div>
                </div>
                <div className={styles.item}>
                  <div>
                    <h4>{t('europass.training_kind')}</h4>
                    <p>{info?.trainings?.slice(-1)[0]?.kind}</p>
                  </div>
                </div>
                <div className={styles.item}>
                  <div>
                    <h4>{t('europass.doc_type')}</h4>
                    <p>{info?.trainings?.slice(-1)[0]?.certification_type}</p>
                  </div>
                </div>
                <div className={styles.item}>
                  <div>
                    <h4>{t('plagiarism.col_document')}</h4>
                    <p>{info?.trainings?.slice(-1)[0]?.certification}</p>
                  </div>
                </div>
              </div>
            </div>
          )}

          {info?.employment?.experiences.length === 0 ? null : (
            <div className={styles.list}>
              <h3>{t('europass.experience')}</h3>
              <div className={styles.item}>
                <input
                  onChange={(e) => setProfession(e.target.checked)}
                  checked={profession}
                  type="checkbox"
                  className={styles.radio}
                />
                <div>
                  <h4>{t('europass.position')}</h4>
                  <p>{info?.employment?.experiences?.slice(-1)[0].position}</p>
                </div>

                <div className={styles.item}>
                  <div>
                    <h4>{t('europass.staff')}</h4>
                    <p>
                      {info?.employment?.experiences?.slice(-1)[0].organization}
                    </p>
                  </div>
                </div>
                <div className={styles.item}>
                  <div>
                    <h4>{t('europass.organization_name')}</h4>
                    <p>
                      {info?.employment?.experiences?.slice(-1)[0].organization}
                    </p>
                  </div>
                </div>
                <div className={styles.item}>
                  <div>
                    <h4>{t('europass.work_start')}</h4>
                    <p>{info?.employment?.experiences?.slice(-1)[0].started}</p>
                  </div>
                </div>
                <div className={styles.item}>
                  <div>
                    <h4>{t('europass.work_end')}</h4>
                    <p>{info?.employment?.experiences?.slice(-1)[0].ended}</p>
                  </div>
                </div>
              </div>
            </div>
          )}

          <button
            className={styles.btn1}
          
            onClick={() => navigate('/finaleuro')}
          >
            Формировать Europass
          </button>
        </div>
      </div>
    </Layout>
  )
}

export default Europass
